import httpClient from "../../api/httpClient";
import Contrato from "../classes/Contrato";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Contrato/All/" },
  { method: "GET", rota: "Contrato/" },
  { method: "POST", rota: "Contrato/Adicionar" },
  { method: "PUT", rota: "Contrato/Atualizar" },
  { method: "DELETE", rota: "Contrato/Apagar" },
  { method: "POST", rota: "Contrato/All" },
];

const cacheKey: string = "ContratoCache";
const cacheKeySelC: string = "ContratoSelecionado";
const apiServico: String = "PLANEJAMENTO"

class ContratoDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }

  Adicionar(value: Contrato): Promise<Contrato> {
    return super.post(calls[2].rota, value)
      .then((result) => {
        return result;
      });
  }

  Atualizar(value: Contrato) {
    let ok: boolean = false;
    let error: any = undefined;
    super.put(calls[3].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  async Apagar(value: Contrato) {
    return await super.delete(calls[4].rota, value).then((result) => {
      return result;
    }).catch((erro) => {
      console.log(erro);
      return(false);
    });
  }

  async ListarAtivos(codigoFornecedorSap: number): Promise<Contrato[]> {
    return await super.Get(calls[0].rota + codigoFornecedorSap)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async ListarAtivosMultiplosParceiros(codigoFornecedorSap: number[]): Promise<Contrato[]> {

    if(codigoFornecedorSap.length == 0) return [];

    let params = '';
    codigoFornecedorSap.forEach(x=> params += `codigoFornecedorSap=${x}&`);

    return await super.Get(calls[5].rota+'?'+params)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  async RecuperarContratoPorParceiroENumero(codigoFornecedorSap: number, numeroContrato: string): Promise<Contrato> {
    return await super.Get(calls[1].rota + codigoFornecedorSap + "/" + numeroContrato)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheClass(): string {
    return cacheKeySelC;
  }

  AdicionarListaAoCache(value: Contrato[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  AdicionarObjetoAoCache(value: Contrato) {
    localStorage.setItem(cacheKeySelC, JSON.stringify(value));
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

  RecuperarObjetoDoCache(): Contrato {
    let result: Contrato = JSON.parse(String(localStorage.getItem(cacheKeySelC)));
    return result;
  }

  ListarFromCache(): Contrato[] {
    let result: Contrato[] = JSON.parse(String(localStorage.getItem(cacheKey)));
    return result;
  }
}
export default ContratoDataset;

